import { HttpClient, HttpEvent, HttpEventType, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

// Environment
import { environment } from "src/environments/environment";

// Models
import { AccountSource } from "src/app/accounts-v2/models/fields/accountSource.model";
import { AddressType } from "src/app/accounts-v2/models/fields/addressType.model";
import { AddressClass } from "src/app/accounts-v2/models/fields/addressClass.model";
import { AnnualRevenue } from "src/app/modules/shared/model/annualRevenue.model";
import { Country } from "src/app/accounts-v2/models/fields/country.model";
import { Currency } from "src/app/modules/shared/model/currency.model";
import { EmployeeCount } from "src/app/modules/shared/model/employeeCount.model";
import { Industry } from "src/app/modules/shared/model/industry.model";
import { Language } from "src/app/accounts-v2/models/fields/language.model";
import { Ownership } from "src/app/modules/shared/model/ownership.model";
import { Rating } from "src/app/modules/shared/model/rating.model";
import { Timezone } from "src/app/modules/shared/model/timezone.model";

@Injectable()
export class CoreHttpService {
    private baseUrl: string = environment.apiUrl;

    constructor(private http: HttpClient) { }

    // Dropdown Values API List
    getAllSources(subterrid = 0): Observable<AccountSource[]> {
        return this.http.get<AccountSource[]>(`${this.baseUrl}Source/SourceMinified?subTerritoryId=${subterrid||0}`);
    }

    getAllEmployeesCounts(subterrid = 0): Observable<EmployeeCount[]> {
        return this.http.get<EmployeeCount[]>(this.baseUrl + `EmployeeCount/EmployeesRangeMinified?subTerritoryId=${subterrid||0}`);
    }

    getAllTimezones(): Observable<Timezone[]> {
        return this.http.get<Timezone[]>(`${this.baseUrl}TimeZone/TimeZoneMinified`);
    }

    getAllCurrencies(): Observable<Currency[]> {
        return this.http.get<Currency[]>(`${this.baseUrl}CurrencyUnit/CurrencyUnitMinified`);
    }

    getAllRatings(): Observable<Rating[]> {
        return this.http.get<Rating[]>(`${this.baseUrl}Rating/RatingMinified`);
    }

    getAllAnnualRevenues(subterrid = 0): Observable<AnnualRevenue[]> {
        return this.http.get<AnnualRevenue[]>(`${this.baseUrl}AnnualRevenue/AnnualRevenueMinified?subTerritoryId=${subterrid||0}`);
    }

    getAllOwnerships(subterrid = 0): Observable<Ownership[]> {
        return this.http.get<Ownership[]>(`${this.baseUrl}Ownership/OwnershipMinified?subTerritoryId=${subterrid||0}`);
    }

    getAllIndustries(subterrid = 0): Observable<Industry[]> {
        return this.http.get<Industry[]>(`${this.baseUrl}Industry/IndustryMinified?subTerritoryId=${subterrid||0}`);
    }

    getAllCountries(): Observable<Country[]> {
        return this.http.get<Country[]>(`${this.baseUrl}Country/CountryMinified`);
    }

    getAllLanguages(): Observable<Language[]> {
        return this.http.get<Country[]>(`${this.baseUrl}Language/LanguageMinified`);
    }

    getAllAddressTypes(): Observable<AddressType[]> {
        return this.http.get<AddressType[]>(`${this.baseUrl}Address/AddressTypeMinified`);
    }

    getAllAddressClasses(): Observable<AddressClass[]> {
        return this.http.get<AddressType[]>(`${this.baseUrl}Address/AddressClassMinified`);
    }
}
